
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
    name: 'ActiveComponent'
})
export default class extends Vue {
    @Prop({default: () => {}})readonly editData!: {useful: number; preVO: {title: string}}
    private evaluate(val: number) {
        this.$emit('evaluate', val)
    }
    private changeContent(val: string) {
        this.$emit('changeContent', val)
    }
}
